<template>
    <div class="energyLabel">
        <div :class="withCustomImageClass ? '' : 'picto'">
            <div class="d-flex align-items-center">
                <button
                    v-if="energyLabel.labelImage"
                    class="border-0 bg-transparent"
                    :data-bs-target="withPopin ? '#modal-energyLabel' + id : null"
                    :data-bs-toggle="withPopin ? 'modal' : null"
                    :data-oevent-category="dataOeventCategory"
                    :data-oevent-label="'indice_' + energyLabel.efficiencyClass"
                    :data-oevent-action="energyLabel.sheetUrl"
                    title="Ouvrir la fiche d'information énergétique du produit"
                    @click="handleLabelClick"
                >
                    <img
                        :class="['align-self-center', withCustomImageClass ? 'img-size' : 'my-1']"
                        :alt="'terminal de classe énergétique ' + energyLabel.efficiencyClass"
                        :src="energyLabel.efficiencyClassImage"
                    >
                </button>

                <a
                    v-else-if="energyLabel.sheetUrl"
                    :href="sheetHref"
                    target="_blank"
                    :data-oevent-category="dataOeventCategory"
                    :data-oevent-label="'indice_' + energyLabel.efficiencyClass"
                    :data-oevent-action="energyLabel.sheetUrl"
                    title="Ouvrir la fiche d'information énergétique du produit"
                >
                    <img
                        :class="['align-self-center', withCustomImageClass ? 'img-size' : 'my-1']"
                        :alt="'terminal de classe énergétique ' + energyLabel.efficiencyClass"
                        :src="energyLabel.efficiencyClassImage"
                    >
                </a>

                <template v-if="withLink">
                    <a
                        v-if="hasLabelOrSheet"
                        :href="sheetHref"
                        target="_blank"
                        class="ps-1"
                    >
                        <strong v-html="energyLabel.popinLinkLabel" />
                    </a>
                </template>
            </div>
        </div>
        <ob1-popin-modal2 v-if="withPopin" :id="'modal-energyLabel' + id" :aria-labelledby="'modal-label-energyLabel' + id">
            <p :id="'modal-label-energyLabel' + id" class="h4" v-html="energyLabel.popinTitle" />
            <img
                alt=""
                class="w-50"
                :src="energyLabel.labelImage"
            >
            <ob1-liens
                v-if="energyLabel.sheetUrl"
                :with-arrow="true"
                :is-large="true"
                :text="energyLabel.sheetLinkLabel"
                :href="sheetHref"
                :target="'_blank'"
            />
        </ob1-popin-modal2>
    </div>
</template>

<script>
export default {
    name: "EnergyLabel",
    props: {
        id:{
            type: String,
            default: ''
        },
        energyLabel: {
            type: Object,
            required: true
        },
        // Pour le sélecteur, on n'a pas besoin du lien à côté du pictogramme
        withLink:{
            type: Boolean,
            default: true
        },
        // Permet de passer une classe CSS personnalisée à l'image (utile pour le sélecteur)
        withCustomImageClass: {
            type: Boolean,
            default: false
        },
        // Quand `false`, le composant n'affiche pas sa propre popin mais émet
        // `energyLabelClick` afin qu'un parent gère une popin unique (cas des listes de tuiles).
        withPopin: {
            type: Boolean,
            default: true
        },
        dataOeventCategory: {
            type: String,
            default: 'fiche_detail_equipement_conso'
        }
    },
    computed: {
        sheetHref: function() {
            return this.energyLabel.sheetUrl + "?webview_action=pdf";
        },
        hasLabelOrSheet() {
            return this.energyLabel.labelImage || this.energyLabel.sheetUrl;
        }
    },
    methods: {
        handleLabelClick() {
            if (!this.withPopin) {
                this.$emit('energyLabelClick', this.id);
            }
        }
    }
};
</script>
<style scoped lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.picto {
    width: px-to-rem(250);
}

.img-size {
    width: px-to-rem(36);
    height: px-to-rem(20);
}
</style>
